export const THEME_MAP = {
  SG: 'SG_HK',
  TJ: 'TJ_HK',
};
